import { list } from './list';

export const lazyLoadImage = (path, ext) => {
  return import(
    /* webpackMode: "lazy-once" */
    `${path}`
  )
    .then(src => ({
      ext: ext === 'svg' ? 'svg' : 'img',
      icon: src.default || '',
    }))
    .catch(err => console.error(err));
};

const normalizeIconName = rawName => {
  let normalizedName = (rawName ?? '').toString().toLowerCase();

  if (normalizedName.startsWith('outcome:') || normalizedName.startsWith('slotegrator:')) {
    normalizedName = normalizedName.split(':').pop();
  } else if (normalizedName.startsWith('winfinity:')) {
    normalizedName = 'winfinityslots';
  } else if (normalizedName.includes(':')) {
    const [providerName, categoryName] = normalizedName.split(':');
    normalizedName = ['slots', 'live-casino', 'crash'].includes(categoryName) ? providerName : categoryName;
  }

  if (normalizedName === 'evolutionoriginal') normalizedName = 'evolution';
  if (normalizedName === 'evolutionezugi') normalizedName = 'ezugi';
  if (normalizedName === 'spinometal') normalizedName = 'spinomenal';
  if (normalizedName === 'pragmatic-rgs') normalizedName = 'pragmatic';
  if (normalizedName === '18 peaches') normalizedName = '18peaches';
  if (normalizedName === 'poly trade') normalizedName = 'gammatrade';
  if (['pragmaticslots', 'pragmaticlivecasino', 'pragmaticbj'].includes(normalizedName)) normalizedName = 'pragmatic';

  return normalizedName;
};

export const getIconByName = async ({ name, type }) => {
  name = normalizeIconName(name);
  let path = './icons/all/light.svg';
  const hasOwnIcon = Boolean(list[name]);
  const imgName = (list[name] ?? list.all)[type];

  const regExp = /(?:\.([^.]+))?$/;
  const regExpMatches = regExp.exec(imgName);
  const ext = regExpMatches ? regExpMatches[1] : '';

  if (name === 'goldenrace') path = `./icons/golden_race/${imgName}`;
  else if (hasOwnIcon) path = `./icons/${name}/${imgName}`;
  else path = `./icons/all/${imgName}`;

  const result = await lazyLoadImage(path, ext);

  return result;
};
